import i18next from 'i18next';

i18next.addResources('es_CL', 'TopSiteMessage', {
  attentive: '¡Atento!',
  scheduledOrder: 'Tienes un pedido programado.',
  tracking: 'Seguimiento',
  trackingOrder: ' de pedido'
});
